import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetAdvertiser } from "../queries/advertisers";
import { ENTITY } from "../constants";

export const AdvertiserBreadcrumb = ({ match }) => {
  // Entity
  const { ADVERTISER } = ENTITY;

  const {
    data: advertiser,
    isLoading,
    isError,
    error,
  } = useGetAdvertiser(match.params.advertiserId);

  if (isLoading) {
    //return <span>Loading...</span>;
    return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
  }

  if (isError && error instanceof NotFoundException) {
    return <span>Not found</span>;
  }

  if (advertiser) {
    return <span>{trimString(advertiser[ADVERTISER.nameField], 20)}</span>;
  }

  return null;
};
